define(["require", "exports", "knockout", "../utils/dateUtils"], function (require, exports, ko, dateUtils) {
    "use strict";
    var UserModel = /** @class */ (function () {
        function UserModel(data) {
            this.Id = ko.observable(0);
            this.Login = ko.observable();
            this.EMail = ko.observable();
            this.isLocked = ko.observable();
            this.IsExternalUser = ko.observable();
            this.LastActivityDate = ko.observable();
            this.LastLoginDate = ko.observable();
            this.CreationDate = ko.observable();
            this.PasswordQuestion = ko.observable();
            this.PasswordAnswer = ko.observable();
            this.Comments = ko.observable();
            this.PhoneNumber = ko.observable();
            this.TwoFactorType = ko.observable();
            this.TwoFactorEnabled = ko.observable();
            this.Password = ko.observable();
            this.NewPassword = ko.observable();
            this.ConfirmPassword = ko.observable();
            this.RoleGroupId = ko.observable(0);
            this.FirstName = ko.observable();
            this.LastName = ko.observable();
            this.ExternalId = ko.observable(0);
            this.ApiKey = ko.observable();
            this.ApiClientId = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, UserModel.Mapping, self);
            }
        }
        UserModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new UserModel(options.data);
            },
            LastActivityDate: {
                update: function (options) { return dateUtils.parseIsoDate(options.data); }
            },
            LastLoginDate: {
                update: function (options) { return dateUtils.parseIsoDate(options.data); }
            },
            CreationDate: {
                update: function (options) { return dateUtils.parseIsoDate(options.data); }
            }
        };
        return UserModel;
    }());
    return UserModel;
});
//# sourceMappingURL=UserModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/UserModel.js
// module id = 274
// module chunks = 2